<template>
  <div class="modal fade" id="modalWish" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button class="close" type="button" data-dismiss="modal" aria-label="Close"><span
                  aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body" v-if="!ordered">
          <span class="modal-title">{{form_title ? form_title : 'Request a Free Quote'}}</span>
          <form
                  class="lead-form"
                  @submit.prevent="submitLead"
                  :class="{'modal-error': errors.length && validated}"
          >
            <div class="lead-form__row">
              <div class="form-group lead-form__field">
                <label class="lead-form__label">Full Name <span class="req">*</span></label>
                <input class="form-control" type="text" v-model.trim="form.user_name"
                       placeholder="John Smith" :class="{'is-invalid': invalid('name')}">
              </div>
              <div class="form-group lead-form__field">
                <label class="lead-form__label">Phone <span class="req">*</span></label>
                <the-mask mask="+1 (###) ###-####" v-model.trim="form.user_phone" class="form-control"
                          placeholder="+1 (___) ___-____" type="tel" :class="{'is-invalid': invalid('phone')}"/>
              </div>
            </div>

            <div class="lead-form__row">
              <div class="form-group lead-form__field">
                <label class="lead-form__label">Email <span class="req">*</span></label>
                <input class="form-control" type="email" v-model.trim="form.user_email"
                       placeholder="you@email.com" :class="{'is-invalid': invalid('email')}">
              </div>
              <div class="form-group lead-form__field">
                <label class="lead-form__label">ZIP Code / City <span class="req">*</span></label>
                <input class="form-control" type="text" v-model.trim="form.user_location"
                       placeholder="e.g. 90210 or Los Angeles" :class="{'is-invalid': invalid('zip')}">
              </div>
            </div>

            <div class="lead-form__row">
              <div class="form-group lead-form__field">
                <label class="lead-form__label">Service Interested In <span class="req">*</span></label>
                <select class="form-control" v-model="form.service" :class="{'is-invalid': invalid('service')}">
                  <option value="" disabled>Select a service…</option>
                  <option v-for="service in services" :key="service" :value="service">{{ service }}</option>
                </select>
              </div>
              <div class="form-group lead-form__field">
                <label class="lead-form__label">Preferred Contact Method</label>
                <select class="form-control" v-model="form.preferred_contact_method">
                  <option v-for="method in contactMethods" :key="method" :value="method">{{ method }}</option>
                </select>
              </div>
            </div>

            <div class="form-group lead-form__field">
              <label class="lead-form__label">Project Photos <span class="lead-form__optional">(optional)</span></label>
              <div class="lead-form__file">
                <input type="file" ref="file" multiple accept="image/*,application/pdf" @change="handleFileUpload"/>
              </div>
              <small v-if="files.length" class="lead-form__file-count">{{ files.length }} file(s) selected</small>
            </div>

            <div class="form-group lead-form__field">
              <label class="lead-form__label">Project Description <span class="req">*</span></label>
              <textarea class="form-control" v-model.trim="form.user_text"
                        :placeholder="`Tell us about your project (min ${minDescription} characters)…`"
                        rows="3" :class="{'is-invalid': invalid('description')}"/>
            </div>

            <div class="error-explanation" v-show="validated && (errors.length || server_errors.length)">
              <span class="error-explanation__title">Please complete the highlighted fields so we can send your request:</span>
              <ul class="error-explanation__list">
                <li class="error-explanation__item" v-for="error in errors" :key="error">{{ error }}</li>
                <li class="error-explanation__item" v-for="error in server_errors" :key="error">{{ error }}</li>
              </ul>
            </div>

            <b-button class="btn btn-dark modal-button" type="submit" :disabled="loading">
              <b-spinner small v-if="loading"></b-spinner>
              <span v-else>Send</span>
            </b-button>
          </form>
        </div>
        <div class="modal-body" v-else>
          <span class="modal-title">Message sent</span>
          <p class="modal-text">We will respond to you shortly. Thank you for your interest!</p>
          <button class="btn btn-dark modal-button_sended" type="button" data-dismiss="modal">OK</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import leadFormMixin from './leadFormMixin'

export default {
  name: 'CallbackForm',
  mixins: [leadFormMixin],
  props: ['form_title', 'project'],
}
</script>
